import React, { useState, FormEvent, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Checkbox, Tooltip } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'

import svgWait2 from './svg/wait2.gif'


import { aticonfig } from './Types'
import { SystemHeader } from './CommonUI';

import { transpileModule } from 'typescript';
import { stringify } from 'querystring';


interface PageInfo {
    n: number
}

var GsbFlag: any;

interface ATIConfigViewProps {
    gsb: AxiosInstance,
    ATIConfig: aticonfig,
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}



function ATIConfigView({ gsb, ATIConfig = {} as aticonfig, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: ATIConfigViewProps) {

    const [isDeletePress, setisDeletePress] = useState(false)


    if (! ("d_ATI_A" in ATIConfig)) return null



    return (
        <div>
            <div className="Row">
                <Button className="Col-1-1" disabled={true} icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                <Button className="Col-2-1" disabled={true} icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" disabled={true} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>

                <Button className="Col-5-1" disabled={true} icon="direction-right" onClick={() => onNextRec()} >Next</Button>
             
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "A" Clients' labelFor="inputATI_A">
                    <InputGroup readOnly value={ATIConfig.d_ATI_A} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "C" Clients' labelFor="inputATI_C">
                    <InputGroup readOnly value={ATIConfig.d_ATI_C} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "I" Clients' labelFor="inputATI_I">
                    <InputGroup readOnly value={ATIConfig.d_ATI_I} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "M" Clients' labelFor="inputATI_M">
                    <InputGroup readOnly value={ATIConfig.d_ATI_M} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "P" Clients' labelFor="inputATI_P">
                    <InputGroup readOnly value={ATIConfig.d_ATI_P} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "F" Clients' labelFor="inputATI_F">
                    <InputGroup readOnly value={ATIConfig.d_ATI_F} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "Other" Clients' labelFor="inputATI_OTHER">
                    <InputGroup readOnly value={ATIConfig.d_ATI_OTHER} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="CCASS/3 Sender BIC" labelFor="inputSEND_BIC">
                    <InputGroup readOnly value={ATIConfig.d_SEND_BIC} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <H5>For HK Market</H5>
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Upload on T+? day for Net Sold" labelFor="inputd_NETSOLDDAY">
                    <InputGroup readOnly value={ATIConfig.d_NETSOLDDAY} />
                    { ATIConfig.d_NETSOLDDAY === "1" && <div id="DispText" >T+1</div> }
                    { ATIConfig.d_NETSOLDDAY === "2" && <div id="DispText" >T+2</div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Upload on T+? day for Net Bought" labelFor="inputd_NETBUYDAY">
                <InputGroup readOnly value={ATIConfig.d_NETBUYDAY} />
                    { ATIConfig.d_NETBUYDAY === "1" && <div id="DispText" >T+1</div> }
                    { ATIConfig.d_NETBUYDAY === "2" && <div id="DispText" >T+2</div> }
                </FormGroup>
            </div>
        </div>
    )
}

interface ATIConfigEditProps {
    gsb: AxiosInstance,
    ATIConfig?: aticonfig,
    isNew?: boolean,
    onSave?: (ATIConfig: aticonfig) => void,
    onCancel?: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function ATIConfigEdit({ gsb, ATIConfig = {} as aticonfig, isNew = false, onSave = () => { }, onCancel = () => { } }: ATIConfigEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<aticonfig>()

    const [def_d_NETSOLDDAY, setdef_d_NETSOLDDAY] = useState(ATIConfig.d_NETSOLDDAY)
    const [def_d_NETBUYDAY, setdef_d_NETBUYDAY] = useState(ATIConfig.d_NETBUYDAY)


    useEffect(() => {
        // Call reset to set default values if ac is passed
        if ("d_ATI_A" in ATIConfig) {
            reset(ATIConfig)
        }
    }, [ATIConfig, reset])

    
    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        //register({ name: "d_status" })
    }, [register])

    
    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])
    
    
    useEffect(() => {
        if ( def_d_NETSOLDDAY.trim().length == 0 ) {
            setdef_d_NETSOLDDAY("2")
        }
        if ( def_d_NETBUYDAY.trim().length == 0 ) {
            setdef_d_NETBUYDAY("2")
        }
    }, [])


    if (! isNew && !("d_ATI_A" in ATIConfig)) return null


    const onSubmit = (data: aticonfig) => {
        //console.log("onsubmit called", data)

        data.d_NETSOLDDAY = def_d_NETSOLDDAY
        data.d_NETBUYDAY = def_d_NETBUYDAY


        ;
        (async () => {
            try {
                //console.log("call ATIConfigedit data", data)
                //console.log("call ATIConfigedit isNew", isNew)
                const res = await gsb.post('/Transaction', {sb_data: data, cPgmId: "Ati_Rpt", cAction: "ATIConfigValidate", isNew: isNew})
                //console.log("ATIConfigedit res.data.ok", res.data.ok)
                //console.log("ATIConfigedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }
                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()


    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "A" Clients' labelFor="inputATI_A">
                    <InputGroup id="inputATI_A" name="d_ATI_A" defaultValue="" placeholder='CCASS A/C for "A" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_A && errors.d_ATI_A.types && <span id="Err_msg">{errors.d_ATI_A.types.message}</span>}
                    {errors.d_ATI_A && errors.d_ATI_A.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "C" Clients' labelFor="inputATI_C">
                    <InputGroup id="inputATI_C" name="d_ATI_C" defaultValue="" placeholder='CCASS A/C for "C" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_C && errors.d_ATI_C.types && <span id="Err_msg">{errors.d_ATI_C.types.message}</span>}
                    {errors.d_ATI_C && errors.d_ATI_C.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "I" Clients' labelFor="inputATI_I">
                    <InputGroup id="inputATI_I" name="d_ATI_I" defaultValue="" placeholder='CCASS A/C for "I" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_I && errors.d_ATI_I.types && <span id="Err_msg">{errors.d_ATI_I.types.message}</span>}
                    {errors.d_ATI_I && errors.d_ATI_I.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "M" Clients' labelFor="inputATI_M">
                    <InputGroup id="inputATI_M" name="d_ATI_M" defaultValue="" placeholder='CCASS A/C for "M" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_M && errors.d_ATI_M.types && <span id="Err_msg">{errors.d_ATI_M.types.message}</span>}
                    {errors.d_ATI_M && errors.d_ATI_M.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "P" Clients' labelFor="inputATI_P">
                    <InputGroup id="inputATI_P" name="d_ATI_P" defaultValue="" placeholder='CCASS A/C for "P" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_P && errors.d_ATI_P.types && <span id="Err_msg">{errors.d_ATI_P.types.message}</span>}
                    {errors.d_ATI_P && errors.d_ATI_P.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "F" Clients' labelFor="inputATI_F">
                    <InputGroup id="inputATI_F" name="d_ATI_F" defaultValue="" placeholder='CCASS A/C for "F" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_F && errors.d_ATI_F.types && <span id="Err_msg">{errors.d_ATI_F.types.message}</span>}
                    {errors.d_ATI_F && errors.d_ATI_F.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label='CCASS A/C for "Other" Clients' labelFor="inputATI_OTHER">
                    <InputGroup id="inputATI_OTHER" name="d_ATI_OTHER" defaultValue="" placeholder='CCASS A/C for "Other" Clients ...' inputRef={register({ maxLength: 8}) } />
                    {errors.d_ATI_OTHER && errors.d_ATI_OTHER.types && <span id="Err_msg">{errors.d_ATI_OTHER.types.message}</span>}
                    {errors.d_ATI_OTHER && errors.d_ATI_OTHER.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-2" label="CCASS/3 Sender BIC" labelFor="inputSEND_BIC">
                    <InputGroup id="inputSEND_BIC" name="d_SEND_BIC" defaultValue="" placeholder="Sender BIC ..." inputRef={register({ maxLength: 8}) } />
                    {errors.d_SEND_BIC && errors.d_SEND_BIC.types && <span id="Err_msg">{errors.d_SEND_BIC.types.message}</span>}
                    {errors.d_SEND_BIC && errors.d_SEND_BIC.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <H5>For HK Market</H5>
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Upload on T+? day for Net Sold" labelFor="inputd_NETSOLDDAY">
                    <select  id="inputd_NETSOLDDAY" value={def_d_NETSOLDDAY} onChange={utils.handleStringChange(s => setdef_d_NETSOLDDAY(s)) }ref={register}>
                        <option value="1">T+1</option>
                        <option value="2">T+2</option>
                    </select>
                    {errors.d_NETSOLDDAY && errors.d_NETSOLDDAY.types && <span id="Err_msg">{errors.d_NETSOLDDAY.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col3-1-2" label="Upload on T+? day for Net Bought" labelFor="inputd_NETBUYDAY">
                    <select  id="inputd_NETBUYDAY" value={def_d_NETBUYDAY} onChange={utils.handleStringChange(s => setdef_d_NETBUYDAY(s)) }ref={register}>
                        <option value="1">T+1</option>
                        <option value="2">T+2</option>
                    </select>
                    {errors.d_NETBUYDAY && errors.d_NETBUYDAY.types && <span id="Err_msg">{errors.d_NETBUYDAY.types.message}</span>}
                </FormGroup>
            </div>
        </form>
    )
}

interface Ati_Rpt1MainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function Ati_Rpt1Main({ gsb }: Ati_Rpt1MainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    const [data, setData] = useState([] as aticonfig[])


    const [searchKey, setSearchKey] = useState("OpenDate")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(false)
    const [showButton, setshowButton] = useState(false)


    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("Detail")
    const [currentAc, setCurrentAc] = useState({} as aticonfig)
    const [BlankAc, setBlankAc] = useState({} as aticonfig)


    const [currentMode, setCurrentMode] = useState("show")

    const [isDark, setIsDark] = useState(document.getElementById("body")?.classList.contains("bp4-dark"))

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    

    
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [userKey, setuserKey] = useState("")
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //gsb default value
    //BlankAc.d_p_Pref = "P"



    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("Ati_Rpt1Main disp user_key: ", res.data.Flag.user_key)
                //console.log("Ati_Rpt1Main disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("Ati_Rpt1Main disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("Ati_Rpt1Main disp GsbFlag: ", GsbFlag)
                //console.log("Ati_Rpt1Main disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("Ati_Rpt1Main disp dateFormat: ", dateFormat)
                //console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("Ati_Rpt1Main disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("Ati_Rpt1Main disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("Ati_Rpt1Main disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                setuserKey(GsbFlag.user_key) ;

                //console.log("Ati_Rpt1Main isProduction: ", GsbFlag.isProduction)
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                //console.log("set StatusList: ", StatusList)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb, currentMode])


    useEffect(() => {

        //console.log("MenuBar cardOpen01", cardOpen01)        
        if ( cardOpen01.substr(0,17) === "cardOpen01-Theme8" ) {
            document.getElementById("body")?.classList.add("bp4-dark")
            setIsDark(true)
        } else {
            document.getElementById("body")?.classList.remove("bp4-dark")
            setIsDark(false)
        }


    }, [gsb, GsbFlag, cardOpen01, currentMode])


    useEffect(() => {

        setnPage(1)
        if ( nPage > 0 ) {
            //setcPrintMode("PS")
        } 

        (async () => {
            try {
                const res = await gsb.post('/Transaction',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "Ati_Rpt",
                        cAction: "ListRec",
                    });
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }

                //console.log("main res.data", res.data.data)
                //console.log("main currentAc", currentAc)
                setCurrentMode("show")

                setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    const PrevRecProcess = async (ATIConfig: aticonfig) => {
    }

    const DeleteProcess = async (ATIConfig: aticonfig) => {
    }

    const NextRecProcess = async (ATIConfig: aticonfig) => {
    }

    const newOnSave = async (ATIConfig: aticonfig) => {
    }

    const editOnSave = async (ATIConfig: aticonfig) => {
        try {
            //console.log("call editOnSave", ATIConfig)
            const res = await gsb.post('/Transaction', {sb_data: ATIConfig, cPgmId: "Ati_Rpt", cAction: "UpdateRec"})
            //showSuccess("Input Date & Time " + ac.d_inpputDate +" "+ ac.d_inpputTime + " record saved")
/*            
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_acCode === res.data.data.d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
*/            
            //setCurrentAc(res.data.data)
            setCurrentAc(res.data.data[0])
            setCurrentMode("show")

        } catch (error) {
            utils.showError(error)
        }
    }



    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }

    // currentMode = show
    let detail = <ATIConfigView gsb={gsb} ATIConfig={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></ATIConfigView>
    switch (currentMode) {
        case "edit":
            detail = <ATIConfigEdit gsb={gsb} ATIConfig={currentAc} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ATIConfigEdit>
            break
        case "new":
            detail = <ATIConfigEdit gsb={gsb} ATIConfig={BlankAc} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } }></ATIConfigEdit>
            break
    }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>



    let list = <>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (
        <>
            <form >
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>ATI Setup</H3>
                    {/*
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                    */}

                    {detail}
                </Card>
            </form>
        </>
    );
}

export default Ati_Rpt1Main